<h1 style="padding-bottom: 1rem">Nowa wersja regulaminu</h1>
<app-info-message
  style="padding-bottom: 5px"
  [labelHTML]="
    'Informujemy, że uległ zmianie regulamin konta na portalu.<br />Jeżeli zgadzasz się z wszystkimi jego postanowieniami, zaznacz pole <strong>Oświadczam, że akceptuję regulamin konta</strong> i kliknij przycisk <strong>Akceptuj regulamin</strong>.'
  "
></app-info-message>

<div
  class="description"
  [innerHTML]="termsAndConditions() | textResource | async | normalizeNbsp | safeHtml"
></div>

<div class="buttons">
  <div class="flex items-center gap-1 buttons">
    @if (termsAndConditions()) {
      <p-checkbox
        [(ngModel)]="isAaccepted"
        [binary]="true"
        [inputId]="'isacceptTermsAndConditions'"
        styleClass="customCheckbox"
      />
      <label [for]="'isacceptTermsAndConditions'" class="ml-2 my-4"
      >Oświadczam, że akceptuję regulamin konta</label
      >
    }
  </div>
  <p-button
    [label]="'Wyloguj'"
    (click)="logOut()"
    styleClass="customDangerButton outlined"
    size="small"
  ></p-button>
  @if (termsAndConditions()) {
    <p-button
      [label]="'Akceptuj regulamin'"
      (click)="acceptTermsAndConditions()"
      [disabled]="!isAaccepted"
      styleClass="customInfoButton"
      size="small"
    ></p-button>
  }
</div>
